import React from "react";
import { resolvePhoto } from "@/lib/api";
import VerifiedBadge from "@/components/VerifiedBadge";

export default function MatchesPanel({ matches, selectedId, unread = {}, onSelect }) {
  return (
    <div className="flex flex-col h-full" data-testid="matches-panel">
      <div className="p-5 border-b border-[#E5DFD3]">
        <h2 className="font-serif text-3xl text-[#1A1818] leading-none">Connections</h2>
        <p className="text-xs uppercase tracking-[0.2em] text-[#737373] mt-2">Mutual yeses</p>
      </div>
      <div className="flex-1 overflow-y-auto">
        {matches.length === 0 ? (
          <div className="p-6 text-sm text-[#737373] font-serif italic" data-testid="no-matches">
            No connections yet — keep reading.
          </div>
        ) : (
          <ul>
            {matches.map((m) => (
              <li key={m.id}>
                <button
                  data-testid={`match-${m.id}`}
                  onClick={() => onSelect(m)}
                  className={`w-full text-left flex items-center gap-3 p-4 border-b border-[#E5DFD3]/60 transition-colors ${
                    selectedId === m.id ? "bg-[#F3E8DD]/60" : "hover:bg-[#F0EBE1]/50"
                  }`}
                >
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-[#F0EBE1] flex-shrink-0">
                    {m.with_user.photos?.[0] ? (
                      <img src={resolvePhoto(m.with_user.photos[0])} alt="" className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center font-serif text-xl text-[#737373]">
                        {m.with_user.name?.[0]}
                      </div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-serif text-lg text-[#1A1818] truncate flex items-center gap-1.5">
                      <span className="truncate">{m.with_user.name}</span>
                      {m.with_user.verified && <VerifiedBadge />}
                    </div>
                    <div className="text-xs text-[#737373] truncate">
                      {m.last_message?.text || "Say something thoughtful"}
                    </div>
                  </div>
                  {unread[m.id] > 0 && (
                    <span data-testid={`unread-${m.id}`}
                      className="ml-2 w-5 h-5 rounded-full bg-[#913831] text-white text-[10px] font-medium flex items-center justify-center flex-shrink-0">
                      {unread[m.id] > 9 ? "9+" : unread[m.id]}
                    </span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
